import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const BookingSlide: React.FC = () => {
  const { t } = useTranslation();
  const m = t('demoTour.mockups.booking', { returnObjects: true }) as any;
  const [selected, setSelected] = useState(1);

  return (
    <div className="dt-mockup-booking">
      <div className="dt-booking-header">
        <div>
          <div className="dt-booking-name">{m.name}</div>
          <div className="dt-booking-sub">{m.subtitle}</div>
        </div>
        <span className="dt-booking-badge">{m.badge}</span>
      </div>
      <div className="dt-booking-slots">
        {m.slots.map((slot: any, i: number) => (
          <div
            key={i}
            className={`dt-booking-slot ${i === selected ? 'dt-booking-slot--active' : ''}`}
            onClick={() => setSelected(i)}
          >
            <div className="dt-booking-slot-day">{slot.day}</div>
            <div className="dt-booking-slot-time">{slot.time}</div>
            <div className="dt-booking-slot-type">{slot.type}</div>
          </div>
        ))}
      </div>
      <button className="dt-booking-btn">{m.button}</button>
    </div>
  );
};

export default BookingSlide;
